import firebase from "firebase/app";
import "firebase/database";

console.log("Hello firebase");
const firebaseConfig = {
  apiKey: "AIzaSyB9SA11guNBI7ZAagBmIhJbhxr7rCnqvuM",
  authDomain: "cockatoo-4d993.firebaseapp.com",
  databaseURL: "https://cockatoo-4d993.firebaseio.com",
  projectId: "cockatoo-4d993",
  storageBucket: "cockatoo-4d993.appspot.com",
  messagingSenderId: "650474912771",
  appId: "1:650474912771:web:22b5b483ad31b97f"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const database = firebase.database();
export { database, firebase as default };
